import React from 'react'
import theme from 'live/services/theme'
import ColorPicker from 'live/components/ui/form/color-picker'
import styled from 'styled-components'
import IconNameTextField from './IconNameTextField'
import i18n from 'live/services/i18n'
import AlarmConfigsContainer from './alarms/AlarmConfigsContainer'
import { cloneDeepGridEditorChannel } from '../../../../../../cloneDeepFunctions'
import NumericField from '../../../../NumericField'
import { AxesSuffix } from 'live/components/widget/ui/y-axis-config/y-axis-config-modal'

interface ChannelConfigsProps {
    channelOption: GridEditorChannelOption
    isEditor?: boolean
    onChange: (configKey: string, newValue: string | boolean | AlarmsProps) => void
    onChangeGroup: (group: GridEditorGroup, updateQuery: boolean) => void
}

export function ChannelConfigs(props: ChannelConfigsProps): React.ReactElement {
    const channelOption: GridEditorChannelOption = cloneDeepGridEditorChannel(props.channelOption) ?? {}

    return (
        <ChannelConfigsContainer>
            <IconAndColorConfigsContainer
                icon={channelOption.__icon}
                iconConfigKey={'__icon'}
                iconColor={channelOption.iconColor}
                iconColorConfigKey={'iconColor'}
                backgroundColor={channelOption.backgroundColor}
                backgroundConfigKey={'backgroundColor'}
                onChange={props.onChange}
                isEditor={props.isEditor}
            />
            <AlarmConfigsContainer
                showAlarmConfigs={channelOption.showAlarmConfigs}
                alarms={channelOption.alarms}
                onChange={props.onChange}
            />
        </ChannelConfigsContainer>
    )
}

const ChannelConfigsContainer = styled.div``

interface IconAndColorConfigsProps {
    icon: string
    iconConfigKey: string
    iconColor: string
    iconColorConfigKey: string
    backgroundColor: string
    backgroundConfigKey: string
    blink?: number
    textFieldHeight?: string
    isEditor?: boolean
    onChange: (configKey: string, newValue: string) => void
}

export function IconAndColorConfigsContainer(props: IconAndColorConfigsProps): React.ReactElement {
    return (
        <>
            <IconNameTextField
                label={`${i18n('Icon name')}:`}
                value={props.icon}
                configKey={props.iconConfigKey}
                onChange={props.onChange}
                height={props.textFieldHeight}
                className={!props.isEditor ? 'dropdown-toggler--cancel-drag' : ''}
            />
            <ColorConfigContainer>
                <ColorPicker
                    value={props.iconColor}
                    onChange={value => props.onChange(props.iconColorConfigKey, value)}
                    size={20}
                    zIndex={21}
                    caretColor={theme.gray}
                    resetColor={''}
                    position="left"
                />
                <label style={{ marginLeft: '7px', paddingTop: '2px' }}>{`${i18n('Icon color')}`}</label>
            </ColorConfigContainer>
            <ColorConfigContainer>
                <ColorPicker
                    value={props.backgroundColor}
                    onChange={value => props.onChange(props.backgroundConfigKey, value)}
                    size={20}
                    zIndex={21}
                    caretColor={theme.gray}
                    resetColor={''}
                    position="left"
                />

                <label style={{ marginLeft: '7px', paddingTop: '2px' }}>{`${i18n('Background color')}`}</label>
            </ColorConfigContainer>
            {props.blink && (
                <div style={{ padding: '10px 11px 0px 11px' }}>
                    <NumericField
                        label={i18n('Blink')}
                        value={props.blink}
                        configKey={'blink'}
                        onChange={props.onChange}
                        minValueAllowed={1}
                        height={props.textFieldHeight}
                        className={!props.isEditor ? 'dropdown-toggler--cancel-drag' : ''}
                    >
                        <AxesSuffix style={{ height: props.textFieldHeight }}>{'ms'}</AxesSuffix>
                    </NumericField>
                </div>
            )}
        </>
    )
}

const ColorConfigContainer = styled.div`
    padding: 7px 11px 0 11px;
    display: flex;
`
